import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Domain } from '@feathr/blackbox';
import { Button } from '@feathr/components';
import { useEntriConnect } from '@feathr/extender/hooks';

interface IProps {
  domain: Domain;
}

function AuthenticateDomainButton({ domain }: Readonly<IProps>): JSX.Element | null {
  const { t } = useTranslation();
  const { canConnect, isOpening, openEntri } = useEntriConnect();

  if (!canConnect(domain)) {
    return null;
  }

  function handleClick(): Promise<void> {
    return openEntri(domain);
  }

  return (
    <Button isLoading={isOpening} onClick={handleClick} type={'primary'}>
      {t('Authenticate domain')}
    </Button>
  );
}

export default observer(AuthenticateDomainButton);
